import { render, staticRenderFns } from "./CategoryBreadcrumb.vue?vue&type=template&id=318c51f4&"
import script from "./CategoryBreadcrumb.vue?vue&type=script&lang=ts&"
export * from "./CategoryBreadcrumb.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryBreadcrumb.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs})
